import { useEffect, useRef } from "react";

import { useTempFilter } from "../../../hooks/filter/useTempFilter";
import { createFilter as apiCreateFilter, updateFilter as apiUpdateFilter } from "../../../resources/filters";

import { LayerInfo } from "../../../interfaces/resourceInfo";

export const useLayerTempFilter = (layer?: LayerInfo, serverCondition?: string, isError?: boolean) => {
  const [tempFilterId, setTempFilterId] = useTempFilter();
  const [createFilter, { data: createdFilterData }] = apiCreateFilter.use();
  const [updateFilter, { data: updatedFilterData }] = apiUpdateFilter.use();
  const firstLoad = useRef<boolean>(true);

  useEffect(() => {
    if (updatedFilterData) {
      setTempFilterId(updatedFilterData.result.id);
    }
  }, [updatedFilterData]); // eslint-disable-line

  useEffect(() => {
    if (!isError && tempFilterId) {
      updateFilter({
        input: {
          name: tempFilterId,
          filterData: {
            filterString: serverCondition ?? "",
          },
        },
      });
    }
  }, [serverCondition]); // eslint-disable-line

  useEffect(() => {
    if (createdFilterData) {
      setTempFilterId(createdFilterData.result.id);
    }
  }, [createdFilterData]); // eslint-disable-line

  useEffect(() => {
    if (tempFilterId === undefined && layer && firstLoad.current) {
      firstLoad.current = false;

      createFilter({
        input: {
          filterData: {
            filterString: layer.configuration.condition ?? "",
          },
        },
      });
    }
  }, [tempFilterId, layer]); // eslint-disable-line
};
